<div class="row" style="padding: 15px 0px;">
    <div class="col-md-6">
        <table>
            <thead>
                <tr height="40px">
                    <th>Alarm</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let stat of alarmStats" height="35px">
                    <td *ngIf="stat.alarmTypeId === 'E'" style="color:red">{{ stat.alarm }}</td>
                    <td *ngIf="stat.alarmTypeId === 'W'">{{ stat.alarm }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-2">
        <table>
            <thead>
                <tr>
                    <th height="40px">Issues</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let stat of alarmStats" height="35px">
                    <td *ngIf="stat.alarmTypeId === 'E'" style="color:red">{{ stat.issues }}</td>
                    <td *ngIf="stat.alarmTypeId === 'W'">{{ stat.issues }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-2">
        <table>
            <thead>
                <tr height="40px">
                    <th>
                        <button mat-raised-button class="black-btn" (click)="exportAlarmsSummary()">EXPORT</button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let stat of alarmStats" height="35px">
                    <td>
                        <button mat-raised-button class="black-btn" (click)="showAlarmRoutes(stat)">Routes</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-md-2"></div>
</div>

<div *ngIf="this.exportSummaryButtonClicked" class="row">    
    <div class="col-md-3"></div>
    <div class="col-md-6">
        <div class="alert alert-success" role="alert">
            <mat-icon>thumb_up</mat-icon> &nbsp;
            <label style="vertical-align: text-bottom; margin-bottom: 0rem;">{{this.exportSummaryMessage}}</label>
        </div>
    </div>
    <div class="col-md-3"></div>    
</div>

<div *ngIf="this.showRoutesButtonClicked" class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
        <div class="alert alert-success" role="alert">
            <mat-icon>thumb_up</mat-icon> &nbsp;
            <label style="vertical-align: text-bottom; margin-bottom: 0rem;">{{this.routesMessage}}</label>
        </div>
    </div>
    <div class="col-md-3"></div>
</div>
<header *ngIf="this.showRoutes">
    <div class="routes_header" style="display:block"></div>
</header>
<div class="row" style="padding: 15px 0px;">
    <div *ngIf="this.showRoutes" class="col-md-8">
        <div class="alarm-name-content">
            <b>Alarm:&nbsp;&nbsp; {{selectedAlarm}} <br> (Note: All Date and Time fields are shown in EST)</b>
        </div>        
    </div>
    <div *ngIf="this.showRoutes" class="col-md-4">
        <button mat-raised-button class="black-btn" (click)="exportRoutes()">EXPORT</button>
    </div>
</div>

<div class="row">
    <div *ngIf="this.showRoutes" class="col-md-12">
        <app-routes [alarmRoutes]="alarmRoutes" [selectedAlarmId]="selectedAlarmId"></app-routes>
    </div>
</div>
